module.exports = __webpack_public_path__ + "static/img/Tom-McDonald.572c7bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-McDonald.jpg
// module id = oITp
// module chunks = 0